import * as types from 'constants/action_types'

export default function doUpdateActiveLabel(index) {
  return {
    type: types.UPDATE_ACTIVE_LABEL_INDEX,
    data: {
      activeLabelIndex: index,
    },
  }
}
